import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { TipoSolicitud } from 'src/app/shared/enumeraciones/tipo-solicitud.enum';
import { RNTPrestadorEntry } from 'src/app/shared/entrys/rnt-prestador.entry';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { Router } from '@angular/router';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-modal-categoria-establecimiento",
  templateUrl: "./modal-categoria-establecimiento.component.html",
  styleUrls: ["./modal-categoria-establecimiento.component.scss"],
})
export class ModalCategoriaEstablecimientoComponent implements OnInit {
  @Input()
  mensaje: string;

  @Input()
  titulo: string;


  @Input()
  rnt:RNTPrestadorEntry;

  constructor(
    public activeModal: NgbActiveModal,
    private router:Router,
    private dataSharedService: DataSharedService
    ) {

    }

  ngOnInit(): void {}

  confirm() {
    if (this.activeModal) {
      this.activeModal.close();
    }
  }

  cancel() {
    if (this.activeModal) {

      this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
        data: this.rnt,
        tipo_solicitud: TipoSolicitud.Cancelacion,
        estado_solicitud: this.rnt.estado_solicitud_id,
        tipo_rnt: this.rnt.tipo_rnt_id,
      });

      this.router.navigate(["otra-solicitudes"]);
      this.activeModal.close();
    }
  }

  abortar(){

    if(this.activeModal){
      this.router.navigate(["/mis-establecimientos"]);
      this.activeModal.close();
    }

  }
}
